export function ScoreRing({
  label,
  value,
}: {
  label: string;
  value: number | null;
}) {
  const safeValue = Math.max(0, Math.min(100, value ?? 0));
  const tone =
    value === null
      ? "empty"
      : value >= 90
        ? "good"
        : value >= 50
          ? "warning"
          : "bad";

  return (
    <div className="score-item">
      <div
        className={`score-ring ${tone}`}
        style={{ "--score": `${safeValue * 3.6}deg` } as React.CSSProperties}
      >
        <span>{value === null ? "—" : Math.round(value)}</span>
      </div>
      <span>{label}</span>
    </div>
  );
}
